import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-no-data-message',
  templateUrl: './no-data-message.component.html',
  styleUrls: ['./no-data-message.component.scss']
})
export class NoDataMessageComponent implements OnInit {
  // todo add border if true
  @Input() showBorder: boolean;

  constructor() { }

  ngOnInit(): void {
  }

}
